"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class CortexController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            get: '/v1/admin/config/cortex',
            test: 'v1/admin/config/cortex/test',
            listResponder: '/connector/cortex/responder/_search',
        };
    }
    list() {
        throw new Error("Can't list cortex");
    }
    count() {
        throw new Error("Can't count cortex");
    }
    create({}) {
        throw new Error("Can't create cortex!");
    }
    // eslint-disable-next-line
    edit(data) {
        return this.manager.put({ url: this.endpoints.get }, data);
    }
    delete() {
        throw new Error("Can't delete cortex!");
    }
    getConfig() {
        return this.manager.get({
            url: this.endpoints.get,
        });
    }
    test(data) {
        return this.manager.post({
            url: this.endpoints.test,
        }, data);
    }
    listResponder() {
        return this.manager.post({
            url: this.endpoints.listResponder,
        });
    }
}
exports.default = CortexController;
